import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { lighthouseDashboardApi } from './slices/LighthouseDashboardConfigSlice'

export const store = configureStore({
  reducer: {
    [lighthouseDashboardApi.reducerPath]: lighthouseDashboardApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(lighthouseDashboardApi.middleware),
})

setupListeners(store.dispatch)